export default __webpack_public_path__ + "static/media/background-utilities-layout.9a242c47.jpg";